import RagnaDataTable from '../ReactComponents/RagnaDataTable';
import RagnaModal from '../ReactComponents/RagnaModal';
import { useState, useEffect } from 'react';
import axios from 'axios';
import { MultiSelect } from '../ReactComponents/MultiSelect';
import Select from 'react-select';
import { ajax_api, getAccess } from '../../Globals';
import { useOutletContext } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const RolesManager = props => {
    //const { API_URL, DELETE_URL, UPDATE_ROLE_URL, GET_ACTIVITIES_URL, GET_ACTIVITIES_BY_ID_URL } = props;
    const [refreshTable] = useOutletContext();
    const API_URL = `${ajax_api}users/roles-list`;
    const DELETE_URL = `${ajax_api}users/delete-role`;
    const UPDATE_ROLE_URL = `${ajax_api}users/update-role`;
    const GET_ACTIVITIES_URL = `${ajax_api}users/get-activities`;

    const [draw, setDraw] = useState(-9999);
    const [activities, setActivities] = useState([{ value: -1, label: "" }]);
    const [loadingActs, setLoadingActs] = useState(true);
    const [modalOpen, setModalOpen] = useState(false);
    const [checkFlag, setCheckFlag] = useState(false);
    const [oldName, setOldName] = useState("");
    const [currentId, setCurrentId] = useState(null);

    const [ms_reflag, set_ms_reflag] = useState(-9999);

    const [editRoleName, setEditRoleName] = useState("");
    const [currActivities, setCurrActivities] = useState([]);
    const [origActivities, setOrigActivities] = useState([]);

    //datatable options
    const table_columns = [
        { display: "ID", col: "Id" },
        { display: "Full Name", col: "Name" },
        { display: "# Activities", col: "Acts" },
        { display: "# Users with Role", col: "Users", dontOrder: true },
    ];
    const search_columns = [
        { display: "Activity", col: "FullName" },
    ];
    useEffect(_ => {
        //get all role activities
        axios.get(GET_ACTIVITIES_URL, { withCredentials: true }).then(r => r.data).then(d => {
            setActivities(d.options);
        }).catch(e => console.log(e))
    }, []);

    const getRoleActivities = id => {
        //get all role activities
        setLoadingActs(true);
        setCheckFlag(false);
        axios.get(GET_ACTIVITIES_URL + "?id=" + id, {withCredentials: true }).then(r => r.data).then(d => {
            var acts = d.result;//.map(r => { return { label: r.FullName, value: r.ID } });
            console.log(acts)
            setCurrActivities(acts);
            setOrigActivities(acts);
        }).catch(e => {
            console.log(e);
        })
        set_ms_reflag(f => f + 1);
        setLoadingActs(false);
    }

    const openModal = row => {
        setEditRoleName(row.Name);
        setOldName(row.Name);
        getRoleActivities(row.Id);
        setCurrentId(row.Id);
        setModalOpen(true);
    }

    return <>
        <Helmet>
            <title>LTS | User Roles Management</title>
        </Helmet>
        <RagnaModal
            modalOpen={modalOpen}
            setModalOpen={setModalOpen}
            width={checkFlag ? 800 : null }
            noBtn={true}
            body={<>
                {
                    checkFlag ? <>
                        <div style={{
                            fontWeight: "bold",
                            fontSize:12
                        } }>
                            Role Name
                        </div>
                        <div>
                            {oldName} <i className="fa fa-arrow-right" /> {editRoleName}
                        </div>
                        <hr className="my-2" />
                        <div className="row">
                            <div className="col">
                                <div style={{
                                    textAlign: "center",
                                    fontSize: 13,
                                    fontWeight: "bold"
                                } }>
                                    New Activities  <span className="badge bg-success">
                                        { currActivities.filter(a => !origActivities.includes(a)).length }
                                    </span>
                                </div>
                                {
                                    currActivities.filter(a => !origActivities.includes(a)).length > 0 ? (
                                        <ol style={{
                                            maxHeight: 300,
                                            overflow: "auto"
                                        } }>
                                            {
                                                currActivities.filter(a => !origActivities.includes(a)).map((a, i) => <li key={i}>{activities.filter(aa => aa.value == a)[0].label}</li>)
                                            }
                                        </ol>
                                    ) : "No added activities"
                                }
                            </div>
                            <div className="col">
                                <div style={{
                                    textAlign: "center",
                                    fontSize: 13,
                                    fontWeight: "bold"
                                }}>
                                    Removed Activities <span className="badge bg-danger">
                                        {origActivities.filter(a => !currActivities.includes(a)).length}
                                    </span>
                                </div>
                                {
                                    origActivities.filter(a => !currActivities.includes(a)).length > 0 ? (
                                        <ol style={{
                                            maxHeight: 300,
                                            overflow: "auto"
                                        }}>
                                            {
                                                origActivities.filter(a => !currActivities.includes(a)).map((a, i) => <li key={i}>{activities.filter(aa => aa.value == a)[0].label}</li>)
                                            }
                                        </ol>
                                    ) : "No removed activities"
                                }

                            </div>
                            <div className="col">
                                <div style={{
                                    textAlign: "center",
                                    fontSize: 13,
                                    fontWeight: "bold"
                                }}>
                                    Retained Activities <span className="badge bg-secondary">
                                        {origActivities.filter(a => currActivities.includes(a)).length}
                                    </span>
                                </div>
                                {
                                    origActivities.filter(a => currActivities.includes(a)).length > 0 ? (
                                        <ol style={{
                                            maxHeight: 300,
                                            overflow: "auto"
                                        }}>
                                            {
                                                origActivities.filter(a => currActivities.includes(a)).map((a, i) => <li key={i}>{activities.filter(aa => aa.value == a)[0].label}</li>)
                                            }
                                        </ol>
                                    ) : "No retained activities"
                                }

                            </div>
                        </div>
                    </> :
                    (loadingActs ? <div className="text-center"><i className="fa fa-pulse fa-spinner" /> Loading data...</div> : <>
                            <div>Role Name: <input onChange={e => setEditRoleName(e.target.value)} className="form-control" value={editRoleName} /></div>
                            <div className="mt-2">
                                <MultiSelect title="Allowed Activities:"
                                    options={activities }
                                    selected={currActivities}
                                    setSelected={setCurrActivities}
                                    resetFilter={ms_reflag }
                                        origValues={origActivities} />
                            </div>
                    </>
                    )
                }
            </>}
            footer={
                checkFlag ? <>
                    <div className="px-2">
                        <button className="ro-button" style={{marginRight:5}} onClick={_ => setCheckFlag(false)}><span>Back</span></button>
                        <button className="ro-button"
                            onClick={_ => {
                                var f = new FormData();
                                f.append("id", currentId);
                                f.append("name", editRoleName);
                                f.append("activities", JSON.stringify(currActivities));
                                console.log(currActivities);

                                axios.post(UPDATE_ROLE_URL, f, { withCredentials: true}).then().then(_ => {
                                    setModalOpen(false);
                                    setDraw(d => d + 1);
                                }).catch(e => {
                                    setCurrActivities(origActivities);
                                    alert(e+", " +e.response.data.Message)
                                });
                                setCheckFlag(false);
                            }
                        }><span>Save Changes</span></button>
                    </div>
                </> :
                    <div className="px-2">
                        <button className="ro-button" onClick={_ => setCheckFlag(true)}><span>Check changes</span></button>
                    </div>
            }
        />
        <RagnaDataTable
            draw={draw}
            refreshTable={refreshTable}
            customEntrySizes={[10, 50, 100, 1000]}
            title="Roles Management Datatable"
            columns={table_columns}
            s_columns={search_columns}
            defaultOrder={true}
            maxPagination={8}
            generalSearch={true}
            defaultOrderCol="ID"
            url={API_URL}
        actions={[
            //{
            //    action: "url", display: "Edit",
            //    content: d => `${VIEW_URL}/${d.ID}`,
            //},
            //{
            //    action: "modal", display: "Edit",
            //    onClick: col => {
            //        getRoleActivities(col.ID);
            //    },
            //    content: (d, setModal) => {
            //        return {
            //            title: "Edit Role Name",
            //            body: <>
            
            //            footer: <div>
            //                <button className="ro-button pr-2" style={{ marginRight: 5 }} onClick={_ => {
            //                    var val = $(ActNameInputRef.current).val();
            //                    axios.get(SET_API_URL, {
            //                        params: {
            //                            id: d.ID,
            //                            newName: val
            //                        }
            //                    }).then(_ => {
            //                        setDraw(d => d + 1);
            //                    }).catch(e => {
            //                        alert("an error occured. check console for details")
            //                        console.log(e);
            //                    })
            //                    setModal(false);

            //                }}>
            //                    <span>Save</span>
            //                </button>
            //            </div>
            //        }
            //    }
            //},
            {
                hideIf: !getAccess(5),
                action: "button", display: "Edit",
                onClick: openModal
            },
            {
                hideIf: !getAccess(6),
                action: "url_confirm", display: "Delete",
                content: d => `${DELETE_URL}?id=${d.Id}`,
                body: d => `Are you sure you want to delete role '${d.Name}' ?`, title: "Delete Data"
            },
        ]}
        />
    </>;
}

export default RolesManager;